module.exports = __webpack_public_path__ + "static/img/logo_txt_x2.7c232c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/department/logo_txt_x2.png
// module id = Rf/4
// module chunks = 1